import Icon from "./Icon";
import "./globals.css";
import hero from "./img/sq07.jpg";
import divani from "./img/sq04.jpg";
import FadeInSection from "./FadeInSection";
import Layout from "./Layout";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import GalleryPage from "./Gallery";
import FAQ from "./FAQ";
import TechStack from "./TechStack";
import ContactForm from "./ContactForm";

export default function App() {
  const [openRow, setOpenRow] = useState(0);

  const toggleRow = (index) => {
    setOpenRow(openRow === index ? null : index);
  };

  const rows = [
    {
      name: "Аудио",
      iconName: "mic",
      content:
        "Звукът е сърцето на всеки добър подкаст. В Storycast използваме микрофони от най-висок клас като Shure SM7B – същите, които се използват от най-успешните световни подкастъри. Всеки участник има индивидуален канал за запис, което позволява кристално чист звук и пълен контрол при обработката.",
      color: "#FF5733", // Orange
    },
    {
      name: "Видео",
      iconName: "video",
      content:
        "Използваме професионални камери като Canon R5C и R6 Mark II за перфектна картина от всеки ъгъл. Можеш да заснемеш широк кадър на цялата сцена или близък план на всеки участник – всичко зависи от визията ти. А ако искаш готово видео веднага след записа, предлагаме и реално време превключване между камери.",
      color: "#33A1FF", // Blue
    },
    {
      name: "Акустика",
      iconName: "acoustic",
      content:
        "Акустиката в студиото е прецизно обработена, така че всеки звук да звучи плътно и професионално – без ехо, шумове и нежелани честоти. Просто влизаш и записваш, без да мислиш за околната среда.",
      color: "#28A745", // Green
    },
    {
      name: "Осветление",
      iconName: "lighting",
      content:
        "Правилното осветление прави огромна разлика. Нашата система включва Amaran и Nanlite осветителни тела с пълен контрол върху температурата и цвета. Това означава чист, кинематографичен кадър – независимо дали снимаш подкаст, интервю или видео съдържание за социални мрежи.",
      color: "#FFC107", // Yellow
    },
  ];

  return (
    <Layout>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="page_width flex flex-col lg:flex-row gap-4 lg:gap-0 items-center justify-between"
      >
        <div className="flex flex-col w-full lg:w-1/2 items-start gap-4 md:pr-8">
          <h1 className="text-3xl">
            Подкаст студио, където идеите ти{" "}
            <b>
              <u>стават реалност.</u>
            </b>
          </h1>
          <p className="text-base">
            Storycast е студио, което ти осигурява всичко необходимо за
            създаването на професионални подкасти, видеа и дигитално съдържание
            - без компромиси в качеството!
            <br />
            <div className="bg-yellow-200 font-bold text-black p-3 rounded-md shadow-[2px_2px_6px_rgba(0,0,0,0.15)] w-10/12 rotate-[-1.5deg] border-l-4 border-yellow-400 my-2">
              Готов епизод веднага след приключване на снимачния процес.
            </div>
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#contact"
              className="relative overflow-hidden border-2 border-black bg-black rounded-full py-3 px-8 text-sm text-white transition-all duration-500 before:absolute before:inset-0 before:bg-white before:translate-x-[-100%] before:transition-transform before:duration-500 hover:text-black hover:before:translate-x-0"
            >
              <span className="relative z-10">Свържи се с нас</span>
            </a>
            <a href="#services" className="text-sm underline font-bold">
              Виж услугите
            </a>
          </div>
        </div>
        <div className="w-full lg:w-1/2 relative">
          <img
            className="object-cover aspect-square rounded-3xl"
            alt="hero"
            src={hero}
          />
        </div>
      </motion.div>
      <div className="lg:hidden h-[1px] w-full bg-[#aaa] mt-16"></div>
      <FadeInSection className="page_width flex flex-col lg:flex-row gap-4 lg:gap-0 items-center justify-between">
        <div className="w-full lg:w-1/2 relative mb-4 lg:mb-0">
          <img
            className="object-cover aspect-square w-full rounded-3xl"
            alt="divani"
            src={divani}
          />
        </div>
        <div className="flex flex-col w-full lg:w-1/2 items-start gap-4 lg:pl-8">
          <h2 className="text-3xl font-bold">
            Всичко нужно за успеха на твоето съдържание
          </h2>
          <div className="w-full">
            {rows.map((row, index) => (
              <div
                key={index}
                className={`border border-border my-2 cursor-pointer rounded-xl px-6 py-5 transition-all duration-300 
                          hover:bg-gray-100 hover:border-black ${
                            openRow === index ? "bg-gray-100" : "bg-white"
                          }`}
                onClick={() => toggleRow(index)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-bold flex items-center gap-2">
                    <Icon
                      iconName={row.iconName}
                      className={`w-5 h-5 text-[${row.color}]`}
                    />
                    {row.name}
                  </h3>
                  <motion.span
                    animate={{ rotate: openRow === index ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-xl"
                  >
                    <Icon iconName="plus" className="text-black w-3 h-3" />
                  </motion.span>
                </div>

                <AnimatePresence>
                  {openRow === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden mt-2"
                    >
                      <p className="text-sm text-gray-700">{row.content}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </FadeInSection>
      <FadeInSection className="page_width flex flex-col gap-4 lg:gap-0 items-center justify-between">
        <div
          style={{ backgroundPosition: "30% 70%" }}
          className="bg-cover bg-divani border w-full flex items-center justify-center rounded-xl py-32"
        >
          <h2 className="text-3xl lg:text-4xl text-white font-bold text-center lg:leading-[52px]">
            Бърз и лесен процес.
            <br />
            Без загуба на време.
          </h2>
        </div>
        <div className="flex flex-col mt-4 lg:flex-row gap-4 lg:gap-0 w-full justify-between items-center">
          <a
            href="#contact"
            className="w-full border-border md:border-black md:border-dashed border lg:w-[32%] rounded-xl md:bg-[#e1e1e1] transition-all duration-500 py-10 md:group cursor-pointer bg-secondary flex items-center justify-center"
          >
            <h3 className="md:text-xl mdunderline transition-all duration-300 text-black font-bold text-xl underline md:underline">
              Резервирай
            </h3>
          </a>
          <div className="w-full border-border border lg:w-[32%] rounded-xl py-10 bg-secondary flex items-center justify-center">
            <h3 className="text-black font-bold text-lg">Записвай</h3>
          </div>
          <div className="w-full border-border border lg:w-[32%] rounded-xl py-10 bg-secondary flex items-center justify-center">
            <h3 className="text-black font-bold text-lg">Публикувай</h3>
          </div>
        </div>
      </FadeInSection>
      <FadeInSection id="tech">
        <h2 className="text-2xl font-bold lg:text-3xl lg:w-1/2 mx-auto text-center mb-8">
          Висок клас оборудване
          <br /> за висок клас съдържание
        </h2>
        <TechStack />
      </FadeInSection>
      <FadeInSection id="gallery" className="page_width">
        <h2 className="text-2xl lg:text-3xl lg:w-1/2 mx-auto text-center mb-8">
          Виж студиото <b>в действие</b>
        </h2>
        <GalleryPage />
      </FadeInSection>
      <FadeInSection id="services" className="bg-secondary w-screen mx-0">
        <h2 className="text-2xl page_width lg:text-3xl lg:w-1/2 mx-auto text-center mb-8">
          Ето и нашите предложения:
        </h2>

        <div className="page_width grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-4 p-4">
          {[
            {
              name: "Standard",
              backgroundColor: "#FFD700",
              foregroundColor: "black",
              border: "#FFD700",
              title: "Единична сесия<br/>за запис",
              features: [
                "Възможност за добавяне на онлайн гост",
                "Суров запис на живото предаване (Live cut broadcast raw files)",
                "Цени от 150€ (293.25лв.)/Започнат час",
                "Готов епизод веднага след края на снимачния процес",
              ],
              variant: "default", // Regular styling
            },
            {
              name: "Pro",
              backgroundColor: "#0190FE",
              foregroundColor: "white",
              border: "unset",
              title: "Сесия запис + обработка",
              features: [
                "Видео обработка - изрязване на нежелани момента от записа",
                "Възможност за добавяне на онлайн гост",
                "Аудио обработка - изолиране на нежелани звуци (кашлица, др)",
                "Предоставяне на избрани моменти за Социални мрежи (Reels, Shorts)",
                "Създаване на Интро и Аутро",
              ],
              variant: "default", // Regular styling
            },
            {
              name: "Live",
              backgroundColor: "#FF1000",
              foregroundColor: "white",
              border: "unset",
              title: "Livestream",
              features: ["Възможност за предаване на живо"],
              variant: "default", // Special styling for this card
            },
          ].map((plan, index) => (
            <div
              key={index}
              className={`relative p-6 flex gap-4 flex-col h-full rounded-2xl shadow-lg items-center ${
                plan.variant === "dark" ? "bg-black text-white" : "bg-white"
              }`}
            >
              <div
                className={`absolute top-0 left-1/2 right-1/2 -translate-y-4 -translate-x-1/2 h-8 w-20 rounded-full border px-4 text-center flex justify-center items-center text-sm`}
                style={{
                  backgroundColor: plan.backgroundColor,
                  color: plan.foregroundColor,
                  borderColor: plan.border,
                }}
              >
                {plan.name}
              </div>
              <h3
                className="text-2xl font-bold text-center"
                dangerouslySetInnerHTML={{ __html: plan.title }}
              ></h3>
              <div
                className={`w-full flex-grow border rounded-2xl flex flex-col gap-4 justify-between items-start p-6 ${
                  plan.variant === "dark"
                    ? "border-none bg-[#292929]"
                    : "border-border bg-secondary"
                }`}
              >
                {plan.features.map((feature, i) => (
                  <div key={i} className="text-sm flex items-center gap-2">
                    <Icon
                      iconName="check"
                      className={`w-4 h-4 text-${
                        plan.variant === "dark" ? "white" : "black"
                      }`}
                    />
                    <p className="flex-1">{feature}</p>
                  </div>
                ))}
              </div>
              <a
                href="#contact"
                className={`w-full rounded-full text-center relative overflow-hidden border-2 border-black bg-black py-3 px-8 transition-all duration-500 before:absolute before:inset-0 before:bg-white before:translate-x-[-100%] before:transition-transform before:duration-500 hover:text-black hover:before:translate-x-0 ${
                  plan.variant === "dark"
                    ? "bg-white text-black"
                    : "bg-black text-white"
                }`}
              >
                <span className="relative z-10">Поискайте оферта</span>
              </a>
            </div>
          ))}
        </div>
      </FadeInSection>
      <FadeInSection className="bg-secondary">
        <div className="page_width">
          <h2 className="text-2xl font-bold lg:text-3xl lg:w-1/2 mx-auto text-center mb-8">
            Всичко, което трябва да знаеш:
          </h2>
          <div className="lg:hidden h-[1px] w-1/2 mx-auto bg-[#aaa] mb-4"></div>
        </div>
        <FAQ />
      </FadeInSection>
      <FadeInSection className="page_width" id="contact">
        <div className="flex flex-col lg:flex-row items-start gap-8 justify-between">
          <div className="flex flex-col gap-4 w-full lg:w-1/3">
            <h3 className="text-2xl font-extrabold">Свържи се с нас</h3>
            <p className="text-base">
              Екипът на Storycast е тук, за да ти помогне със създаването на
              качествено дигитално съдържание. Използвай контактната форма или
              един от долуописаните методи за връзка с нас.
            </p>
            <h5 className="text-lg font-semibold underline">
              За връзка с нас:
            </h5>
            <a
              href="tel:+359899370377"
              className="flex items-center gap-2 hover:underline hover:font-bold"
            >
              <Icon iconName="phone" className="w-6 h-6" />
              +359 899 370 377
            </a>
            <a
              href="mailto:ivayloevoivanov@gmail.com"
              className="flex items-center gap-2 hover:underline hover:font-bold"
            >
              <Icon iconName="email" className="w-6 h-6" />
              ivayloevoivanov@gmail.com
            </a>
            <a
              href="maps.google.com"
              rel="noreferrer"
              className="flex items-center gap-2 hover:underline hover:font-bold"
            >
              <Icon iconName="address" className="w-6 h-6" />
              ул. "Клокотница", 38
            </a>
            <h5 className="text-lg font-semibold underline">
              Или на лично съобщение:
            </h5>
            <a
              href="https://www.instagram.com/storycastbg/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 hover:underline hover:font-bold"
            >
              <Icon iconName="instagram" className="w-6 h-6" />
              storycastbg
            </a>
            <a
              href="https://www.facebook.com/people/Storycast-%D0%9F%D0%BE%D0%B4%D0%BA%D0%B0%D1%81%D1%82-%D0%A1%D1%82%D1%83%D0%B4%D0%B8%D0%BE/61576088187154/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 hover:underline hover:font-bold"
            >
              <Icon iconName="facebook" className="w-6 h-6" />
              storycastbg
            </a>
          </div>
          <ContactForm formName="contact" />
        </div>
      </FadeInSection>
      <div className="w-full text-sm text-center my-4">
        Работно време: Понеделник - Петък 12:00 - 18:00
      </div>
    </Layout>
  );
}
